import { createStandardAction } from 'typesafe-actions';

export const changeToken = createStandardAction('CHANGE_TOKEN')<string>();
